import React from "react";
import { isHM } from "src/utils/userSegment";

function NoomText() {
  return (
    <svg
      css={{ height: "100%" }}
      viewBox="0 0 594.734 133.4"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Noom</title>
      <path
        d="M594.3 131.6h-22.1V25.4l-33.4 57.8c-3.8 6.7-10.9 10.9-18.6 10.8-7.7 0-14.9-4.1-18.7-10.8l-33.4-58.3v106.7H446V23.8c0-11.9 9.7-21.5 21.6-21.5 7.7 0 14.8 4.1 18.6 10.8l34 59.8 34-59.8c5.9-10.3 19.1-13.9 29.4-8 6.7 3.8 10.8 10.9 10.8 18.7l-.1 107.8Zm-498.9 0c-7.7 0-14.8-4.2-18.5-10.9L22.1 24.9v106.7H0V23.8C0 11.9 9.6 2.3 21.4 2.2c7.8 0 14.9 4.1 18.8 10.9L95 108.9V2.2h22.1v107.9c.1 9.8-6.5 18.4-16 20.8-1.9.5-3.8.7-5.7.7Zm110.7 1.8c-36.8 0-66.6-29.8-66.6-66.6S169.3.2 206.1.2s66.6 29.8 66.6 66.6c.1 36.7-29.5 66.5-66.2 66.6h-.4Zm0-111.2c-24.4 0-43.6 19.6-43.6 44.6-.2 11.9 4.4 23.4 12.7 31.9 17 17 44.6 17 61.6 0 8.3-8.5 12.8-20 12.7-31.9.1-25-19-44.6-43.4-44.6Zm151 111.2c-36.8 0-66.6-29.8-66.6-66.6S320.3.2 357.1.2s66.6 29.8 66.6 66.6c.1 36.7-29.5 66.5-66.2 66.6h-.4Zm0-111.2c-24.4 0-43.6 19.6-43.6 44.6-.1 11.9 4.4 23.4 12.7 31.9 17 17 44.6 17 61.6 0 8.3-8.5 12.8-20 12.7-31.9 0-25-19.1-44.6-43.4-44.6Z"
        fill="currentColor"
      />
    </svg>
  );
}

function WeightPill() {
  return (
    <svg
      // Height needs to be set or else the pill logo will not show on safari
      css={{ marginLeft: 7, height: "100%" }}
      viewBox="633.124 0 446.876 133.4"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Weight Logo</title>
      <path
        d="M1015.2 2.2H698c-35.8 0-64.8 29-64.8 64.7 0 35.8 29 64.8 64.7 64.8h317.3c35.8 0 64.8-29 64.8-64.8 0-35.7-29-64.7-64.8-64.7ZM749.4 93.7h-6.2l-12.1-34.8-11.8 34.8h-6.2l-16.3-50.9h8.8l11 34.3 11.7-34.3h6.2L746.3 77l11-34.2h8.6l-16.5 50.9Zm61.3 0h-30.5V42.8h29.7v8h-21v11.6h16.3v8h-16.3v15.3h21.8v8Zm25.5 0h-8.7V42.9h8.7v50.8Zm63.6-9.1c-4.6 5.8-12 9.8-20.2 9.8-15.8 0-26.6-11.2-26.6-26.1 0-15 11.3-26.1 26.1-26.1 7.7 0 14.4 3.3 18.9 8.2l-5.4 5.4c-3.4-3.3-7.8-5.7-13.5-5.7-10.1 0-17.3 8-17.3 18.1 0 10.1 7.3 18.1 17.9 18.1 4.9 0 8.6-1.5 11.8-4.1V70.3h-14.1v-7.6h22.4v21.9Zm60.9 9.1H952V70.5h-26.1v23.2h-8.7V42.8h8.7v19.6H952V42.8h8.7v50.9Zm51.6-42.9h-13.8v42.9h-8.7V50.8H976v-8h36.3v8Z"
        fill="currentColor"
      />
    </svg>
  );
}

function MoodPill() {
  return (
    <svg
      // Height needs to be set or else the pill logo will not show on safari
      css={{ marginLeft: 7, height: "100%" }}
      viewBox="633.124 0 366.721 129.7"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Mood Logo</title>
      <path
        d="
          M935.045-.212 698 .2c-35.8 0-64.8 29-64.8 64.7 0 35.8 29 64.8 64.7 64.8l237.145-.412c35.8 0 64.8-29 64.8-64.8 0-35.7-29-64.7-64.8-64.7Z
          M800.862 43.252c18.344 9.981 17.402 37.564-1.579 46.404-17.392 8.097-36.615-4.449-36.645-23.914-.035-20.009 20.542-32.114 38.224-22.49Zm63.943 0c18.342 9.981 17.401 37.564-1.582 46.404-17.39 8.097-36.612-4.449-36.644-23.914-.032-20.009 20.543-32.114 38.226-22.49m-152.639 11.2c5.21 7.656 9.76 13.913 10.115 13.903.351-.012 4.766-6.276 9.81-13.924 8.222-12.467 9.474-13.901 12.114-13.901h2.949v51.566h-8.199l-.284-17.274-.28-17.276-8.132 11.756-8.131 11.757-1.916-2.475c-1.054-1.361-4.588-6.528-7.853-11.481-7.685-11.653-7.487-11.864-7.487 7.978v17.015h-8.252V40.53h3.036c2.745 0 3.953 1.346 12.51 13.922m209.527-12.307c17.5 5.961 22.225 30.564 8.233 42.848-5.988 5.257-9.832 6.376-23.686 6.889l-12.636.464V40.53h11.678c7.886 0 13.214.525 16.411 1.615m-141.122 6.54c-17.612 7.997-11.506 36.193 7.838 36.193 10.822 0 16.8-6.172 17.297-17.842.657-15.519-11.625-24.488-25.135-18.351m63.945 0c-17.615 7.997-11.508 36.193 7.834 36.193 10.823 0 16.802-6.172 17.298-17.842.657-15.519-11.623-24.488-25.132-18.351m57.338 17.775v18.712l8.095-.556c28.781-1.971 28.135-36.864-.683-36.864h-7.412V66.46Z"
        fillRule="evenodd"
        fill="currentColor"
      />
    </svg>
  );
}

export function NoomLogo({
  pill,
  className,
  onSecretClick,
}: {
  /**
   * Omit for for default behavior for vertical.
   * true to always include.
   * false to never include
   */
  pill?: boolean;
  className?: string;

  /**
   * Allows for intentionally non-accessible click handling
   * to support features like the secret quick silver launcher.
   * Use of this is discouraged for any user facing features.
   */
  onSecretClick?: () => void;
}) {
  let pillEl: JSX.Element;
  if ((pill == null && isHM()) || pill) {
    pillEl = isHM() ? <MoodPill /> : <WeightPill />;
  }

  return (
    /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/no-static-element-interactions */
    <span
      onClick={onSecretClick}
      css={{ display: "flex", height: "100%" }}
      className={className}
    >
      <NoomText />
      {pillEl}
    </span>
  );
}
